// extracted by mini-css-extract-plugin
module.exports = {"content":"AdvDetailedTooltip_content__t3imH"};